import configs from './config.json';
import {Api} from "./Api";
import {UserApi} from "./UserApi";

export class BenefitApi {


    static getBenefit = async (data, response, error) => {
        await Api.get(`${configs.benefit}/${data}`, null, response, UserApi.getAuthorizedHeader(), error);

    }

    static getAllBenefit = async ( response, error) => {
        await Api.get(`${configs.benefit}`, null, response, UserApi.getAuthorizedHeader(), error);
    }

    static insertBenefit = async (data, response, error) => {
        await Api.post(`${configs.benefit}`, data, response, UserApi.getAuthorizedHeader(), error);

    }

    static updateBenefit = async (data, id, response, error) => {
        await Api.put(`${configs.benefit}/${id}`, data, response, UserApi.getAuthorizedHeader(), error);

    }

    static deleteBenefit = async (id, response, error) => {
        await Api.delete(`${configs.benefit}/${id}`, null, response, UserApi.getAuthorizedHeader(), error);
    }

}